import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const EXTREMITIES_FORM_INITIAL_VALUES = {
  sections: {
    extremities: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamExtremitiesSections = keyof typeof EXTREMITIES_FORM_INITIAL_VALUES.sections;
